export enum DetectionStatus {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}
